import NotificationComponent from '../components/notification/notification'

const Notification = () => <NotificationComponent />

export default Notification;